<template>
  <div>
    <div class="container py-5">
      <div class="placeholder" v-if="!isContentLoaded">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="square"></div>
          </div>
          <div class="col-12 col-md-6 pl-md-4 pl-lg-5">
            <div class="page-title mb-4" style="width: 50%;"></div>
            <div class="paragraph mb-3" style="width: 100%;"></div>
            <div class="paragraph mb-3" style="width: 90%;"></div>
            <div class="paragraph mb-3" style="width: 90%;"></div>
            <div class="paragraph mb-3" style="width: 80%;"></div>
          </div>
        </div>
      </div>
      <!-- /.placeholder -->
      <div v-if="isContentLoaded">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="gallery">
              <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                <swiper-slide class="gallery-media" v-for="gallery in content.acf.gallery" :key="gallery.id">
                  <div class="media-container">
                    <img :src="gallery.url" class="img-fluid swiper-lazy" :alt="gallery.alt">
                    <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </div>
                </swiper-slide>
              </swiper>

              <swiper :options="swiperOptionThumbs" class="gallery-thumbs mt-3" ref="swiperThumbs">
                <swiper-slide class="thumb" v-for="gallery in content.acf.gallery" :key="gallery.id">
                  <img :src="gallery.sizes.thumbnail" class="img-fluid" alt="gallery.alt">
                </swiper-slide>
              </swiper>
            </div>
            <!-- /.gallery -->
          </div>
          <div class="col-12 col-md-6 pl-md-4 pl-lg-5 mt-4 mt-md-0">
            <h1 class="page-title mb-4" v-html="content.title.rendered"></h1>

            <div class="page-content mb-4" v-html="content.content.rendered"></div>

            <a :href="content.acf.product_url" class="btn dark" target="_blank" v-if="content.acf.product_url" v-html="$t('message.buy')"></a>

            <div class="page-content mt-4" v-html="content.acf.remark" v-if="content.acf.remark"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '@/assets/sass/gallery.sass'
export default {
  name: 'Accessories',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      content: [],
      isContentLoaded: false,
      swiperOptionTop: {
        spaceBetween: 0,
        autoHeight: true,
        lazy: true
      },
      swiperOptionThumbs: {
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 5,
        touceRatio: 0.2,
        slideToClickedSlide: true,
        lazy: true
      }
    }
  },
  mounted () {
    this.getContent()
  },
  methods: {
    getContent () {
      const lang = this.$route.params.lang
      const $vm = this
      const slug = encodeURIComponent(this.$route.params.slug)
      axios.get(`${this.api_path}wp-json/wp/v2/accessories/`, {
        params: {
          slug,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.content = res.data[0]
            document.title = `${$vm.content.title.rendered} - ${$vm.title}`
            $vm.isContentLoaded = true
            $vm.$nextTick(() => {
              const swiperTop = $vm.$refs.swiperTop.swiper
              const swiperThumbs = $vm.$refs.swiperThumbs.swiper
              swiperTop.controller.control = swiperThumbs
              swiperThumbs.controller.control = swiperTop
            })
          }
        })
    }
  }
}
</script>
